import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function usePdfExport(endpoint, filename) {
  const [exporting, setExporting] = useState(false);

  const handleExport = async (params = {}) => {
    setExporting(true);
    try {
      const queryString = Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null)
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join('&');
      const url = queryString ? `${API}${endpoint}?${queryString}` : `${API}${endpoint}`;
      const response = await axios.get(url, {
        
        responseType: 'blob'
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const finalName = typeof filename === 'function' ? filename(params) : filename;
      link.setAttribute('download', `${finalName}_${new Date().toISOString().slice(0, 10)}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success('PDF exported successfully');
    } catch (err) { console.error(err);
      toast.error('Failed to export PDF');
    } finally {
      setExporting(false);
    }
  };

  return { exporting, handleExport };
}
